




































































































































import { Component, Mixins } from "vue-property-decorator";
import { db, IVIPUser, IVIPContact } from "@/loader/public";
import { VIPCompanyEditComponentMixin } from '@/mixins/VIPCompanyMixin';

@Component
export default class CompanyEdit extends Mixins(VIPCompanyEditComponentMixin) {
	public get contacts(): IVIPContact[] {
		return [{ id: null, name: "Aucun" }, ...this.item.contacts];
	}

	public get users(): IVIPUser[] {
		return [{ id: null, last_name: "Aucun" }, ...db.users.list];
	}

	public unmount() {
		if (this.changed) {
			this.cancel();
		}
	}
}
